import { LocationFragment } from '@/graphql'

export type Address = Pick<
  LocationFragment,
  'address1' | 'city' | 'state' | 'postalCode' | 'county'
>

const extractAddressFromGooglePlaceResult = (placeResult: any): Address => {
  const components = placeResult.address_components

  const getAddressComponent = (
    type: string,
    longName: boolean = true,
  ): string => {
    const component = components.find((c: { types: string[] }) =>
      c.types.includes(type),
    )
    return component
      ? longName
        ? component.long_name
        : component.short_name
      : ''
  }

  return {
    address1:
      `${getAddressComponent('street_number')} ${getAddressComponent('route')}`.trim(),
    city: getAddressComponent('locality'),
    state: getAddressComponent('administrative_area_level_1', false),
    postalCode: getAddressComponent('postal_code'),
    county: getAddressComponent('administrative_area_level_2'),
  }
}

const toString = (location: LocationFragment): string => {
  return `${location.address1}, ${location.city}, ${location.state} ${location.postalCode}`
}

export const LocationHelpers = {
  toString,
  extractAddressFromGooglePlaceResult,
}
